import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class GroupConfig {
    @JsonProperty("id")
    id: number;

    @JsonProperty("label")
    label: string;
}
